import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from 'react';
import Editor from './Editor';
const HtmlEditor = ({ value, onSave, onChange, truncateAt = 500, }) => {
    const [code, setCode] = React.useState(value || '');
    const [copyStatus, setCopyStatus] = React.useState('Copy');
    const editorRef = useRef(null);
    const TRUNCATE_AT = truncateAt; // Limit for truncation
    const handleSave = (savedValue) => {
        setCode(savedValue);
        onSave && onSave(savedValue);
    };
    const handleChange = (value) => {
        onChange && onChange(value);
    };
    const handleCopy = () => {
        navigator.clipboard.writeText(code).then(() => {
            setCopyStatus('Copied');
            setTimeout(() => {
                setCopyStatus('Copy');
            }, 1000);
        });
    };
    const handleCodeClick = () => {
        editorRef.current?.handleOpen();
    };
    const truncateCode = (content, maxLength) => {
        if (content.length > maxLength) {
            return content.substring(0, maxLength) + '...';
        }
        return content;
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "border rounded-lg", children: [_jsxs("div", { className: "flex justify-between p-4 px-6 rounded-lg", children: [_jsx("div", { className: "", children: "HTML Editor" }), _jsxs("div", { className: "space-x-4", children: [_jsx("button", { className: "text-slate-400", onClick: handleCopy, children: copyStatus }), _jsx(Editor, { ref: editorRef, initialValue: code, onSave: handleSave, onChange: handleChange })] })] }), _jsx("div", { className: "w-full", children: _jsx("code", { "data-testid": "code-block", onClick: handleCodeClick, className: "block bg-gray-50 p-4 shadow-inner text-sm font-mono text-gray-800 whitespace-pre-wrap min-h-[200px]", children: truncateCode(code, TRUNCATE_AT) || '' }) })] }) }));
};
export default HtmlEditor;
